import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch } from '../../../../redux';
import { publishOffer } from '../../../../redux/reducers';
import {
  selectIsPublicationAvailable,
  selectTotalPrice,
  selectIsPublishButtonPending,
} from '../../../../selectors/checkoutInfo';
import { selectIsNewOffer } from '../../../../selectors/offer';
import { selectIsPublishToHiddenBase } from '../../../../selectors/publishAvailable';
import { selectIsSubscriptionSelected } from '../../../../selectors/publishTerms';
import { openModal } from '../../../../utils/modals';
import { PayAndPublish } from './PayAndPublish';
import { getPublishButtonText } from './utils';

export const PayAndPublishContainer = () => {
  const totalPrice = useSelector(selectTotalPrice);
  const isPending = useSelector(selectIsPublishButtonPending);
  const isPublicationAvailable = useSelector(selectIsPublicationAvailable);
  const isNewOffer = useSelector(selectIsNewOffer);
  const isSubscriptionSelected = useSelector(selectIsSubscriptionSelected);
  const isPublishToHiddenBase = useSelector(selectIsPublishToHiddenBase);

  const isDisabled = isPending || !isPublicationAvailable && !isPublishToHiddenBase;

  const text = getPublishButtonText({
    totalPrice,
    isNewOffer,
    isSubscriptionSelected,
    isPublishToHiddenBase,
  });

  const dispatch = useDispatch<TDispatch>();

  const handleButtonClick = React.useCallback(() => {
    if (isSubscriptionSelected && !isPublishToHiddenBase) {
      openModal('PackageBuyConfirmationModal');
    } else {
      dispatch(publishOffer({ isPremoderationSkip: false }));
    }
  }, [dispatch, openModal, isSubscriptionSelected, isPublishToHiddenBase]);

  return (
    <PayAndPublish
      text={text}
      handleButtonClick={handleButtonClick}
      isDisabled={isDisabled}
      isPending={isPending}
    />
  );
};
